import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHamburger = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m3 5h18" }),
			/* @__PURE__ */ _jsx("path", { d: "m3 12h18" }),
			/* @__PURE__ */ _jsx("path", { d: "m3 19h18" })
		]
	})
});
export default SvgHamburger;
